import "./navigationLeft.scss";
import CifTitleLogo from "assets/imgs/icons/cifSidebarLogo.png";
import cifFullLogo from "assets/imgs/icons/logo-white-cif.png";
import SessionHistory from "assets/imgs/icons/SessionHistoryIcon.svg";

import { useContext, useState } from "react";

import { useQueries } from "@tanstack/react-query";
import { Link, Routes, useNavigate } from "react-router-dom";
import { ROUTES } from "routes";
import { AuthContext } from "context/AuthContext";

import whiteBoard from "assets/imgs/icons/whiteboard.svg";
import updateCard from "assets/imgs/icons/updateCard.svg";
import referralStatus from "assets/imgs/icons/referralStatus.svg";
import schedule from "assets/imgs/icons/schedule.svg";
import progressReport from "assets/imgs/icons/progressReport.svg";
import studentRecords from "assets/imgs/icons/studentRecords.svg";
import homeworkTool from "assets/imgs/icons/homeworkTool.svg";
import SearchIcon from "assets/imgs/CSMSidebar/searchIconNoBg.svg";

// import Whiteboard from "components/Whiteboard";
import getProfile from "service/user/shared/get-profile";
import hasUnreadMessage from "service/chat/hasUnreadMessage";
import { useEffect } from "react";

function NavigationLeft() {
  const [joinedAsStudent, setJoinAsStudent] = useState(false);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(true);
  const [active, setActive] = useState(0);
  // const [showWhiteBoard, setShowWhiteBoard] = useState(false);
  const [userName, setUserName] = useState();
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [expandSidebar, setExpandSidebar] = useState(false);

  const { authState, isStudent } = useContext(AuthContext);
  useQueries({
    queries: [
      {
        queryKey: ["profile", authState?.userInfo?.cifNumber],
        queryFn: () => getProfile(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,

        onSuccess: (d) => {
          console.log(d);
          setUserName(d.userName);
          d?.joinedAsStudent === 1
            ? setJoinAsStudent(true)
            : setJoinAsStudent(false);
        },
      },
      {
        queryKey: ["unread-messages", authState?.userInfo?.cifNumber],
        queryFn: () => hasUnreadMessage(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber && !isStudent(),
        onSuccess: (s) => setHasUnreadMessages(s),
      },
    ],
  });
  const navigate = useNavigate();

  const addHoverEvent = () => {
    const mainDiv = document.getElementById("parent-sidebar-main");
    mainDiv.addEventListener("mouseenter", () => setExpandSidebar(true));
    mainDiv.addEventListener("mouseleave", () => {
      const expandDiv = document.getElementById("parent-sidebar-expanded");
      expandDiv.addEventListener("mouseenter", () => setExpandSidebar(true));
      expandDiv.addEventListener("mouseleave", () => setExpandSidebar(false));
    });
    // console.log(div);
  };

  // const renderTooltip = (props) => (
  //   <Tooltip id="sidebar-tooltip">{props}</Tooltip>
  // );

  useEffect(() => {
    addHoverEvent();
  }, []);

  return (
    <div className="parent-sidebar-wrapper">
      <div className="navigation__left-wrapper" id="parent-sidebar-main">
        <Link
          className={`row text-center sidebar-cif-logo-wrapper ${
            expandSidebar && "default-cursor"
          }`}
          to={isStudent() ? ROUTES.STUDENT_DASHBOARD : ROUTES.HOME}
        >
          <div>
            <img
              src={CifTitleLogo}
              alt=""
              className={`left_menu_img ${expandSidebar && "invisible"}`}
            />
          </div>
        </Link>
        <div className="row ">
          {isStudent() ? (
            <div className="col-12 col-lg-12 text-center navigation__left-item navigation__link">
              <a
                className="col-12 sidebar__item_col cursor-pointer"
                id="start-whiteboard"
                href={`https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`}
                target="popup"
                onClick={() => {
                  window.open(
                    `https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`,
                    "popup",
                    "width=1300,height=650,left=20,top=20"
                  );
                  return false;
                }}
              >
                <div
                  className={`navigationLeft__icon_wrapper ${
                    active == 1 && "active"
                  }`}
                  onMouseEnter={() => setActive(1)}
                  onMouseLeave={() => setActive(0)}
                >
                  <img
                    style={{ height: "20px", width: "20px" }}
                    src={whiteBoard}
                    alt=""
                    className="left_menu_img"
                  />
                </div>
              </a>
            </div>
          ) : (
            <>
              {" "}
              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2"
                tag="a"
                to={ROUTES.FIND_TUTOR}
                action="true"
              >
                <div
                  className={`navigationLeft__icon_wrapper ${
                    active == 2 && "active"
                  }`}
                  onMouseEnter={() => setActive(2)}
                  onMouseLeave={() => setActive(0)}
                >
                  <img
                    style={{ height: "20px", width: "20px" }}
                    src={SearchIcon}
                    alt=""
                    className="left_menu_img"
                  />
                </div>
              </Link>
              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2"
                tag="a"
                to={ROUTES.STUDENT_RECORDS}
                action="true"
              >
                <div
                  className={`navigationLeft__icon_wrapper ${
                    active == 3 && "active"
                  }`}
                  onMouseEnter={() => setActive(3)}
                  onMouseLeave={() => setActive(0)}
                >
                  <img
                    style={{
                      height: "20px",
                      width: "20px",
                    }}
                    src={studentRecords}
                    alt=""
                    className="left_menu_img"
                  />
                </div>
              </Link>
            </>
          )}
        </div>
        <hr className="hr-sidebar" />
        {isStudent() && (
          <>
            <div className="row mt-3">
              <div className="col-12 col-lg-12 text-center navigation__left-item navigation__link ">
                <a
                  className="col-6 sidebar__item_col cursor-pointer"
                  id="start-whiteboard"
                  href={`https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SHW`}
                  target="popup"
                  onClick={() => {
                    window.open(
                      `https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SHW`,
                      "popup",
                      "width=1300,height=650,left=20,top=20"
                    );
                    return false;
                  }}
                >
                  <div
                    className={`navigationLeft__icon_wrapper ${
                      active == 4 && "active"
                    }`}
                    onMouseEnter={() => setActive(4)}
                    onMouseLeave={() => setActive(0)}
                  >
                    <img
                      style={{ height: "20px", width: "20px" }}
                      src={homeworkTool}
                      alt=""
                      className="left_menu_img"
                    />
                  </div>
                </a>
              </div>
            </div>
            <hr className="hr-sidebar" />
          </>
        )}

        {!isStudent() && (
          <>
            <div className="row mt-3">
              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link"
                tag="a"
                to={ROUTES.PROGRESS_REPORT}
                action="true"
              >
                <div
                  className={`navigationLeft__icon_wrapper ${
                    active == 5 && "active"
                  }`}
                  onMouseEnter={() => setActive(5)}
                  onMouseLeave={() => setActive(0)}
                >
                  <img
                    style={{ height: "20px", width: "20px" }}
                    src={progressReport}
                    alt=""
                    className="left_menu_img"
                  />
                </div>
              </Link>
              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2"
                tag="a"
                to={ROUTES.VIEW_SCHEDULE}
                action="true"
              >
                <div
                  className={`navigationLeft__icon_wrapper ${
                    active == 6 && "active"
                  }`}
                  onMouseEnter={() => setActive(6)}
                  onMouseLeave={() => setActive(0)}
                >
                  <img
                    style={{ height: "20px", width: "20px" }}
                    src={schedule}
                    alt=""
                    className="left_menu_img"
                  />
                </div>
              </Link>

              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2"
                tag="a"
                to={ROUTES.REFERRAL_STATUS}
                action="true"
              >
                <div
                  className={`navigationLeft__icon_wrapper ${
                    active == 7 && "active"
                  }`}
                  onMouseEnter={() => setActive(7)}
                  onMouseLeave={() => setActive(0)}
                >
                  <img
                    style={{
                      height: "20px",
                      width: "20px",
                      marginLeft: "3px",
                    }}
                    src={referralStatus}
                    alt=""
                    className="left_menu_img"
                  />
                </div>
              </Link>
            </div>
            <hr className="hr-sidebar" />
            <div className="row mt-3 ">
              <a
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link"
                onClick={() => navigate(ROUTES.SESSION_NOTES)}
              >
                <div
                  className={`navigationLeft__icon_wrapper ${
                    active == 11 && "active"
                  }`}
                  onMouseEnter={() => setActive(11)}
                  onMouseLeave={() => setActive(0)}
                >
                  <img
                    style={{
                      height: "20px",
                      width: "20px",
                    }}
                    src={SessionHistory}
                    alt=""
                    className="left_menu_img"
                  />
                </div>
              </a>
            </div>
            <div className="row mt-3 ">
              <a
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link"
                onClick={() => navigate(ROUTES.UPDATE_BILLING)}
              >
                <div
                  className={`navigationLeft__icon_wrapper ${
                    active == 8 && "active"
                  }`}
                  onMouseEnter={() => setActive(8)}
                  onMouseLeave={() => setActive(0)}
                >
                  <img
                    style={{
                      height: "20px",
                      width: "20px",
                    }}
                    src={updateCard}
                    alt=""
                    className="left_menu_img"
                  />
                </div>
              </a>
            </div>
            {/* <hr className="hr-sidebar" /> */}
          </>
        )}

        {!isStudent() && joinedAsStudent ? (
          <>
            <div className="row mt-3">
              <div className="col-12 col-lg-12 text-center navigation__left-item navigation__link">
                <a
                  className="col-12 sidebar__item_col cursor-pointer"
                  id="start-whiteboard"
                  href={`https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`}
                  target="popup"
                  onClick={() => {
                    window.open(
                      `https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`,
                      "popup",
                      "width=1300,height=650,left=20,top=20"
                    );
                    return false;
                  }}
                >
                  <div
                    className={`navigationLeft__icon_wrapper ${
                      active == 9 && "active"
                    }`}
                    onMouseEnter={() => setActive(9)}
                    onMouseLeave={() => setActive(0)}
                  >
                    <img
                      style={{ height: "20px", width: "20px" }}
                      src={whiteBoard}
                      alt=""
                      className="left_menu_img"
                    />
                  </div>
                </a>
              </div>

              <div className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2">
                <a
                  className="col-12 sidebar__item_col cursor-pointer"
                  id="start-whiteboard"
                  href={`https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SHW`}
                  target="popup"
                  onClick={() => {
                    window.open(
                      `https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SHW`,
                      "popup",
                      "width=1300,height=650,left=20,top=20"
                    );
                    return false;
                  }}
                >
                  <div
                    className={`navigationLeft__icon_wrapper ${
                      active == 10 && "active"
                    }`}
                    onMouseEnter={() => setActive(10)}
                    onMouseLeave={() => setActive(0)}
                  >
                    <img
                      style={{ height: "20px", width: "20px" }}
                      src={homeworkTool}
                      alt=""
                      className="left_menu_img"
                    />
                  </div>
                </a>
              </div>
            </div>
            {/* <hr className="hr-sidebar" /> */}
          </>
        ) : (
          ""
        )}

        <a
          id="start-whiteboard"
          className="d-none"
          href={`https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`}
          target="popup"
          onClick={() => {
            window.open(
              `https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`,
              "popup",
              "width=1300,height=650,left=20,top=20"
            );
            return false;
          }}
        ></a>
      </div>
      <div
        className={`parent-sidebar-expand ${expandSidebar ? "visible" : ""}`}
        id="parent-sidebar-expanded"
      >
        <Link
          className="row text-center sidebar-cif-logo-wrapper"
          to={isStudent() ? ROUTES.STUDENT_DASHBOARD : ROUTES.HOME}
        >
          <div className="expanded-menu-img-wrapper">
            <img src={cifFullLogo} alt="" className="expanded_menu_img" />
          </div>
        </Link>
        <div className="row">
          {/* <Link
          className="col-12 col-lg-12 text-center navigation__left-item navigation__link"
          tag="a"
          to={isStudent() ? ROUTES.STUDENT_DASHBOARD : ROUTES.HOME}
          action="true"
        >
          <div className="navigationLeft__icon_wrapper">
            <img src={HomeIcon} alt="" className="left_menu_img" />
          </div>
          <small className="d-block mt-1 text-white font-sm">Home</small>
        </Link> */}

          {isStudent() ? (
            <div className="col-12 col-lg-12 text-center navigation__left-item navigation__link">
              <a
                className="col-12 sidebar__item_col cursor-pointer"
                id="start-whiteboard"
                href={`https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`}
                target="popup"
                onClick={() => {
                  window.open(
                    `https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`,
                    "popup",
                    "width=1300,height=650,left=20,top=20"
                  );
                  return false;
                }}
              >
                <div
                  className={`navigationLeft__expanded-label ${
                    active == 1 && "active"
                  }`}
                  onMouseEnter={() => setActive(1)}
                  onMouseLeave={() => setActive(0)}
                >
                  WhiteBoard
                </div>
              </a>
            </div>
          ) : (
            <>
              {" "}
              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2"
                tag="a"
                to={ROUTES.FIND_TUTOR}
                action="true"
              >
                <div
                  className={`navigationLeft__expanded-label ${
                    active == 2 && "active"
                  }`}
                  onMouseEnter={() => setActive(2)}
                  onMouseLeave={() => setActive(0)}
                >
                  Find Tutor
                </div>
              </Link>
              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2"
                tag="a"
                to={ROUTES.STUDENT_RECORDS}
                action="true"
              >
                <div
                  className={`navigationLeft__expanded-label ${
                    active == 3 && "active"
                  }`}
                  onMouseEnter={() => setActive(3)}
                  onMouseLeave={() => setActive(0)}
                >
                  Student Records
                </div>
              </Link>
            </>
          )}
        </div>
        <hr className="hr-sidebar" />
        {isStudent() && (
          <>
            <div className="row mt-3">
              <div className="col-12 col-lg-12 text-center navigation__left-item navigation__link ">
                <a
                  className="col-6 sidebar__item_col cursor-pointer"
                  id="start-whiteboard"
                  href={`https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SHW`}
                  target="popup"
                  onClick={() => {
                    window.open(
                      `https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SHW`,
                      "popup",
                      "width=1300,height=650,left=20,top=20"
                    );
                    return false;
                  }}
                >
                  <div
                    className={`navigationLeft__expanded-label ${
                      active == 4 && "active"
                    }`}
                    onMouseEnter={() => setActive(4)}
                    onMouseLeave={() => setActive(0)}
                  >
                    Homework Tool
                  </div>
                </a>
              </div>
            </div>
            {/* <hr className="hr-sidebar" /> */}
          </>
        )}

        {!isStudent() && (
          <>
            <div className="row mt-3">
              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link"
                tag="a"
                to={ROUTES.PROGRESS_REPORT}
                action="true"
              >
                <div
                  className={`navigationLeft__expanded-label ${
                    active == 5 && "active"
                  }`}
                  onMouseEnter={() => setActive(5)}
                  onMouseLeave={() => setActive(0)}
                >
                  Progress Report
                </div>
              </Link>
              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2"
                tag="a"
                to={ROUTES.VIEW_SCHEDULE}
                action="true"
              >
                <div
                  className={`navigationLeft__expanded-label ${
                    active == 6 && "active"
                  }`}
                  onMouseEnter={() => setActive(6)}
                  onMouseLeave={() => setActive(0)}
                >
                  View Schedule
                </div>
              </Link>

              <Link
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2"
                tag="a"
                to={ROUTES.REFERRAL_STATUS}
                action="true"
              >
                <div
                  className={`navigationLeft__expanded-label ${
                    active == 7 && "active"
                  }`}
                  onMouseEnter={() => setActive(7)}
                  onMouseLeave={() => setActive(0)}
                >
                  Referral Status
                </div>
              </Link>
            </div>
            <hr className="hr-sidebar" />
            <div className="row mt-3">
              <a
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link"
                onClick={() => navigate(ROUTES.SESSION_NOTES)}
              >
                <div
                  className={`navigationLeft__expanded-label ${
                    active == 11 && "active"
                  }`}
                  onMouseEnter={() => setActive(11)}
                  onMouseLeave={() => setActive(0)}
                >
                  Session History
                </div>
              </a>
            </div>
            <div className="row mt-3">
              <a
                className="col-12 col-lg-12 text-center navigation__left-item navigation__link"
                onClick={() => navigate(ROUTES.UPDATE_BILLING)}
              >
                <div
                  className={`navigationLeft__expanded-label ${
                    active == 8 && "active"
                  }`}
                  onMouseEnter={() => setActive(8)}
                  onMouseLeave={() => setActive(0)}
                >
                  Update Card
                </div>
              </a>
            </div>
            {/* <hr className="hr-sidebar" /> */}
          </>
        )}

        {!isStudent() && joinedAsStudent ? (
          <>
            <div className="row mt-3">
              <div className="col-12 col-lg-12 text-center navigation__left-item navigation__link">
                <a
                  className="col-12 sidebar__item_col cursor-pointer"
                  id="start-whiteboard"
                  href={`https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`}
                  target="popup"
                  onClick={() => {
                    window.open(
                      `https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SWB`,
                      "popup",
                      "width=1300,height=650,left=20,top=20"
                    );
                    return false;
                  }}
                >
                  <div
                    className={`navigationLeft__expanded-label ${
                      active == 9 && "active"
                    }`}
                    onMouseEnter={() => setActive(9)}
                    onMouseLeave={() => setActive(0)}
                  >
                    Whiteboard
                  </div>
                </a>
              </div>

              <div className="col-12 col-lg-12 text-center navigation__left-item navigation__link mt-2">
                <a
                  className="col-12 sidebar__item_col cursor-pointer"
                  id="start-whiteboard"
                  href={`https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SHW`}
                  target="popup"
                  onClick={() => {
                    window.open(
                      `https://whiteboardv3-0.codeisfun.com/whiteboard/v4_10n/whiteboard.jsp?uname=${userName}&tt=SHW`,
                      "popup",
                      "width=1300,height=650,left=20,top=20"
                    );
                    return false;
                  }}
                >
                  <div
                    className={`navigationLeft__expanded-label ${
                      active == 10 && "active"
                    }`}
                    onMouseEnter={() => setActive(10)}
                    onMouseLeave={() => setActive(0)}
                  >
                    Homework Tool
                  </div>
                </a>
              </div>
            </div>
            {/* <hr className="hr-sidebar" /> */}
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default NavigationLeft;
